import { Temporal } from '@js-temporal/polyfill';

export const createDateFromInstant = (instant: Temporal.Instant): Date | undefined => {
  const date = new Date(instant.epochMilliseconds);
  if (isNaN(date.getTime())) {
    throw new Error(`Invalid date: ${instant}`);
  }
  return date;
};
